import { gql } from '@apollo/client';

export const TERMINATE_SESSION_MUTATION = gql`
  mutation TerminateSession($id: ID!, $password: String!) {
    terminateSession(id: $id, password: $password) {
      ... on TerminateSessionSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
